import api from './api';
let callbackInfo = {
    ret: false,
    message: '',
    type: 'pki',
    userIds: [],
    path: ''
};
export default {
    validateLogonByPKI(login, callback) {
        let param = {
            status: 0
        };
        api.listPKIInfo(JSON.stringify(param), response => {
            if (response.data.statusCode && response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                window.vue.$log.error('/auth/pkiLogin/listPKIInfo', response);
                callbackInfo.ret = false;
                callbackInfo.message = response.data.statusMessage;
                callback(callbackInfo);
            }
            if (response.data.content.length == 0) {
                callbackInfo.ret = false;
                callbackInfo.message = window.vue.$t('pki.PKI_ENABLE_NONE');
                callback(callbackInfo);
            } else {
                callbackInfo.path = response.data.content[0].path;
                if (callbackInfo.path.length == 0) {
                    callbackInfo.ret = false;
                    callbackInfo.message = window.vue.$t('pki.PKI_MANUFACTOR_PATH_NONE');
                    callback(callbackInfo);
                }
                callbackInfo.ret = true;
                callback(callbackInfo);
            }
        });
    },
    //检测是否满足开启pki登录的条件
    async checkProcess() {
        return new Promise(function(resolve, reject) {
            let param = {
                status: 0
            };
            api.listPKIInfo(JSON.stringify(param), response => {
                if (response.data.statusCode && response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    window.vue.$log.error('/auth/pkiLogin/listPKIInfo', response);
                    callbackInfo.ret = false;
                    callbackInfo.message = response.data.statusMessage;
                    resolve(callbackInfo);
                }
                if (response.data.content.length == 0) {
                    callbackInfo.ret = false;
                    callbackInfo.message = window.vue.$t('pki.PKI_ENABLE_NONE');
                    resolve(callbackInfo);
                } else {
                    callbackInfo.ret = true;
                    resolve(callbackInfo);
                }
            });
        });
    }
};
